import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Box, CircularProgress, Container, Grid, IconButton, Typography } from "@mui/material";
import AuthService from "../Auth/AuthService";
import OfferCard from "./OfferCard";
import { Add } from "@mui/icons-material";
import ModalView from "../model/ModelView";
import AddSubscriptionPlan from "./AddSubscriptionPlan";

const SubscriptionPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(AuthService.tokenInfo())
  const hasFetched = useRef(false);
  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchPlan();

  }, []);

  const fetchPlan = async () => {
    axios
      .get(AuthService.pathUrl("GET", "/subscription/plans"))
      .then((res) => {
        if (userInfo?.roles === 'SUPERADMIN')
          setPlans(res?.data || []);
        else {
          const activePlans = res?.data.filter(p => p.active).filter(plan => plan.name.includes("Standard") || plan.name.includes("Basic") || plan.name.includes("Starter") || plan.name.includes("Premium"));
          setPlans(activePlans || []);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch subscription plans:", error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleOpen = () => {
    setOpenForm(true);
  };

  const handleClose = () => {
    setOpenForm(false);
  };

  if (loading) return (
    <Box display="flex" justifyContent="center" mt={5}>
      <CircularProgress />
    </Box>
  );

  return (
    <div style={{ padding: 20 }}>
      <Container maxWidth={false} disableGutters sx={{ width: '100vw' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
          <Typography variant="h4" textAlign="center" mb={3} >
            🎉 Subscription Offers for you
          </Typography>
          {userInfo?.roles === 'SUPERADMIN' && (
            <IconButton color="warning" onClick={() => handleOpen()} title='Add Subscription'>
              <Add sx={{ border: '2px solid', fontWeight: 'bold', borderRadius: '10px' }} />
            </IconButton>
          )}
        </Box>
        <Grid container spacing={4} justifyContent={'space-evenly'} >
          {plans.map((plan, index) => (
            <Grid item xs={8} sm={6} md={4} key={index}>
              <OfferCard plan={plan}
                userInfo={userInfo}
                onSuccess={() => fetchPlan()} />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* <Container maxWidth={false} disableGutters sx={{ width: '100vw', px: 4, mt: 4 }}>
      {plans ? (
        <Grid container spacing={4} justifyContent={'center'} textAlign={'right'} >
          {plans.map((plan) => (
            <Grid item xs={12} sm={6} md={4} key={plan.id}>
              <Card
                elevation={6}
                sx={{
                  color: 'white',
                  width: "400px",
                  borderRadius: 4,
                  border: plan.name.toLowerCase().includes("premium") ? "2px solid #fbbf24" : "2px solid #523c01",
                  backgroundColor: "#1b1914",
                  background: 'linear-gradient(to right, #1b1914, #302c23ff)',
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.10)",
                    // backgroundColor: '#010a23'
                  }
                }}
              >
                <CardContent sx={{
                  color: 'white'
                }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" fontWeight="bold" >
                      {plan.name}
                    </Typography>
                    {plan.name.toLowerCase().includes("premium") && (
                      <Chip icon={<Star />} label="Premium" color="warning" size="small" />
                    )}
                  </Box>

                  <Typography variant="body2" color="#fff" gutterBottom>
                    Access for {plan.durationInDays} days
                  </Typography>

                  <Divider sx={{ my: 2, borderColor: '#fff' }} />

                  <Typography
                    variant="body1"
                    color="#fff"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      minHeight: 48 // matches 2 lines of text height
                    }}
                  >
                    {plan.description}
                  </Typography>

                  <Typography variant="h6" color="#fff" fontWeight="bold">
                    ₹{plan.price}
                  </Typography>
                </CardContent>

                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: '20px',
                      backgroundColor: '#1b1914',
                      '&:hover': { backgroundColor: '#503e02ff' }
                    }}
                    fullWidth
                    onClick={() => subscribe(plan)}
                  >
                    Subscribe Now
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <div>Data not found</div>
      )}
    </Container> */}
      <ModalView
        open={openForm}
        handleClose={handleClose}
        title="➕ Add Subscription Plan"
        content={<AddSubscriptionPlan onSuccess={() => { setOpenForm(false); fetchPlan() }} />}
      />
    </div>
  );

};

export default SubscriptionPlans;
